import { render, staticRenderFns } from "./tableCadastralOvam.vue?vue&type=template&id=4c9498e9&scoped=true"
import script from "./tableCadastralOvam.vue?vue&type=script&lang=js"
export * from "./tableCadastralOvam.vue?vue&type=script&lang=js"
import style0 from "./tableCadastralOvam.vue?vue&type=style&index=0&id=4c9498e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9498e9",
  null
  
)

export default component.exports